import { ref, computed, reactive, onUnmounted } from "vue";
import dashboardApi from "../api";

export default function (type, chartType = "bar") {
  const resizeFontSize = () => {
    Object.assign(data, {
      ...data,
      options: {
        ...data.options,
        xaxis: {
          ...data.xaxis,
          labels: {
            ...data.labels,
            style: {
              fontSize: window.innerWidth < 1400 ? "10px" : "12px",
            },
          },
        },
      },
    });
  };
  window.addEventListener("resize", resizeFontSize);

  const data = reactive({
    series: [],
    options: {
      chart: {
        fontFamily: "Source Sans Pro, Arial, sans-serif",
        type: chartType,
        parentHeightOffset: 0,
        toolbar: {
          show: false,
        },
      },
      labels: [],
      legend: {
        show: false,
        showForSingleSeries: true,
        position: "right",
        horizontalAlign: "right",
        verticalAlign: "center",
      },
      colors: ["#5B9BD5"],
      yaxis: {
        labels: {
          style: {
            fontSize: "15px",
          },
        },
      },
      xaxis: {
        labels: {
          trim: true,
          minHeight: 150,
          maxHeight: 0,
          formatter: (v) => {
            const lineLength = 18;
            if (v.length > lineLength) {
              const spaces = v.matchAll(/[\s-]/g);
              let closestSpaceIdx = 0;
              let minValue = 0;
              let prevMatch = null;
              for (const match of spaces) {
                minValue = lineLength - match.index;
                closestSpaceIdx = match.index;
                if (minValue === 0) {
                  break;
                } else if (minValue < 0) {
                  closestSpaceIdx =
                    Math.abs(minValue) <
                    lineLength - (prevMatch?.index ?? match.index)
                      ? match.index
                      : prevMatch?.index ?? match.index;
                  break;
                }
                prevMatch = match;
              }
              let firstLine = v.substr(0, closestSpaceIdx);
              var remainingPart = v.substr(closestSpaceIdx).trim();
              return [firstLine, remainingPart];
            }
            return v;
          },
          style: {
            fontSize: window.innerWidth < 1400 ? "10px" : "12px",
          },
        },
      },
      tooltip: {
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          formatter: (v, opts) => {
            return (
              opts.w.globals.labels[opts.dataPointIndex] + ": " + v + " чел."
            );
          },
          title: {
            formatter: () => {
              return "";
            },
          },
        },
      },
    },
  });
  const total = ref(0);

  const loadReport = async () => {
    try {
      const res = await dashboardApi.getPMPKReport({ type });
      //total.value = 0;
      total.value = res.data?.length;
      // total.value = res.data.reduce(
      //   (acc, curr) => (acc += curr.count),
      //   total.value
      // );

      if (res.data.length > 10) res.data = res.data.slice(0, 10);

      Object.assign(data, {
        ...data,
        series: [{ name: "", data: res.data.map((item) => item.count) }],
        options: {
          ...data.options,
          xaxis: {
            categories: res.data.map((item) => {
              if (item.text) {
                return item.text;
              } else return "Не указано";
            }),
          },
        },
      });
    } catch (e) {
      console.log(e);
    }
  };
  onUnmounted(() => {
    window.removeEventListener("resize", resizeFontSize);
  });
  loadReport();
  return {
    data: computed(() => data),
    loadReport,
    total: computed(() => total),
  };
}
